import React from "react";
import { Col, Row } from "reactstrap";
import FileChart from "./FileChart";
import FileChartDonut from "./FileChartDonut";
import "./index.scss";
import { pieChartOptions, barGraphOptions } from '../../../../utils/constants';

const FileChartsBlock = ({
  barColor = ["#66e0e0", "#f081aa"],
  className = "",
  totalPackets,
  totalFiles,
  handlePacketClick,
  handleFileClick,
  handlePieChartClickOption,
  packetLoading,
  fileLoading,
  pieChartLoading,
  pieChartData,
 

}) => {

  return (
    <>
      <div className={`file-charts-blc ${className}`}>
        <Row>
          <Col lg="6" xl="6" className="d-flex flex-column mb-sm-4">
            <FileChart
              barColor={barColor[0]}
              data={totalPackets}
              headingLabel={"Packets Uploaded"}
              className="flex-fill"
              handleClick={handlePacketClick}
              loading={packetLoading}
              options={barGraphOptions}
              
            />
          </Col>
          <Col lg="6" xl="6" className="d-flex flex-column mb-sm-4">
            <FileChart
              barColor={barColor[1]}
              data={totalFiles}
              headingLabel={"Total Documents"}
              className="flex-fill"
              handleClick={handleFileClick}
              loading={fileLoading}
              options={barGraphOptions}
            />
          </Col>
          {/* <Col lg="12" xl="4" className="d-flex flex-column mb-lg-4">
            <FileChartDonut
              headingLabel={"Packets Uploaded"}
              className="flex-fill"
              data={pieChartData}
              loading={pieChartLoading}
              handleClick={handlePieChartClickOption}
              options={pieChartOptions}
            />
          </Col> */}
        </Row>
      </div>
    </>
  );
};
export default FileChartsBlock;
